'use strict';

var React = require('react');
var styles = require('./styles.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

const Control = React.forwardRef(({ containerClassName, containerStyle, ...props }, ref) => {
    const isValidIconDisplayed = props.valid;
    const hasSuffix = props.suffix || props.valid;
    return (React__default.default.createElement(styles.Styled.Container, { disabled: props.disabled, errored: props.errored, className: containerClassName, style: containerStyle },
        props.prefix && (React__default.default.createElement(styles.Styled.PrefixSuffix, { placement: "left", disabled: props.disabled }, props.prefix)),
        React__default.default.createElement(styles.Styled.Control, { ...props, ref: ref }),
        hasSuffix && (React__default.default.createElement(styles.Styled.PrefixSuffix, { placement: "right" }, isValidIconDisplayed ? (React__default.default.createElement(styles.Styled.ValidIcon, { name: "validate-circle-outlined", size: "m", placement: "right", disabled: props.disabled })) : (props.suffix)))));
});

exports.Control = Control;
//# sourceMappingURL=component.js.map
